export default "__VITE_ASSET__Cv9pFZj4__"